import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';
import { AgaveEmployeeEntity, AgaveLocation, AgaveProject } from 'API';

interface AgaveLocationsDropdownProps {
  disabled?: boolean;
  disableHeader?: boolean;
  selectedLocation?: AgaveLocation | null;
  selectedProject?: AgaveProject | null;
  selectedEmployee?: AgaveEmployeeEntity | null;
  onValueChange: (option: AgaveLocation | null) => void;
  placeholder?: string;
  enabled?: boolean;
  /** Load options only when dropdown opens (use in table rows to avoid stale shared state). */
  fetchOnlyOnOpen?: boolean;
}

const AgaveLocationsDropdown = ({
  disabled,
  disableHeader = true,
  selectedLocation,
  selectedProject,
  selectedEmployee,
  onValueChange,
  placeholder,
  enabled = true,
  fetchOnlyOnOpen,
}: AgaveLocationsDropdownProps) => {
  return (
    <CodingEntityDropdown<AgaveLocation>
      entityType="locations"
      selectedItem={selectedLocation}
      projectId={selectedProject?.id}
      employeeId={selectedEmployee?.id}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
      placeholder={placeholder}
      identifierField="name"
      enabled={enabled}
      fetchOnlyOnOpen={fetchOnlyOnOpen}
    />
  );
};

export default AgaveLocationsDropdown;
